/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ActionFlag {
    STATIC_FLAG_ZERO = 'staticFlagZero',
    STATIC_FLAG_ONE = 'staticFlagOne',
    STATIC_FLAG_TWO = 'staticFlagTwo',
    STATIC_FLAG_THREE = 'staticFlagThree',
    STATIC_FLAG_FOUR = 'staticFlagFour',
    STATIC_FLAG_FIVE = 'staticFlagFive',
    STATIC_FLAG_SIX = 'staticFlagSix',
    STATIC_FLAG_SEVEN = 'staticFlagSeven',
    DYNAMIC_FLAG_ZERO = 'dynamicFlagZero',
    DYNAMIC_FLAG_ONE = 'dynamicFlagOne',
    DYNAMIC_FLAG_TWO = 'dynamicFlagTwo',
    DYNAMIC_FLAG_THREE = 'dynamicFlagThree',
    DYNAMIC_FLAG_FOUR = 'dynamicFlagFour',
    DYNAMIC_FLAG_FIVE = 'dynamicFlagFive',
    DYNAMIC_FLAG_SIX = 'dynamicFlagSix',
    DYNAMIC_FLAG_SEVEN = 'dynamicFlagSeven'
}


export function instanceOfActionFlag(value: any): boolean {
    for (const key in ActionFlag) {
        if (Object.prototype.hasOwnProperty.call(ActionFlag, key)) {
            if (ActionFlag[key as keyof typeof ActionFlag] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActionFlagFromJSON(json: any): ActionFlag {
    return ActionFlagFromJSONTyped(json, false);
}

export function ActionFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionFlag {
    return json as ActionFlag;
}

export function ActionFlagToJSON(value?: ActionFlag | null): any {
    return value as any;
}

export function ActionFlagToJSONTyped(value: any, ignoreDiscriminator: boolean): ActionFlag {
    return value as ActionFlag;
}

